module.exports = __webpack_public_path__ + "img/postnl-logo.9df94bff.svg";